// 全局函数
import store from '@/store'
import dayjs from 'dayjs'
import { Message } from 'element-ui'
import { enumList } from '@/utils/globalEnumeration'

const install = function (Vue) {
  /**
   * 返回切割后的日期
   * @param {*} time
   * @returns
   */
  Vue.prototype.cutTime = function (time, character = ' ', sub = 0) {
    if (!time) return '-'
    return time.split(character)[sub]
  }

  /**
   * 字符串转数组
   * @param {*} value     值
   * @param {*} separator 分隔符
   * @returns
   */
  Vue.prototype.stringToArray = function (value, separator = ',') {
    if (!value) return ''
    return value.trim().split(separator)
  }

  /**
   * 处理枚举
   * @param {*} key
   * @param {*} value
   * @returns
   */
  Vue.prototype.dictType = function (key, value, label) {
    if (!label) label = 'label'
    if (value === null || value === '') return '-'
    if (!enumList.hasOwnProperty(key)) return '-'
    const flag = enumList[key].findIndex(item => Number.parseInt(item.value) === Number.parseInt(value))
    const flag_other = enumList[key].findIndex(item => item.otherEnum & (Number.parseInt(item.otherEnum) === Number.parseInt(value)))
    if (flag === -1 && flag_other == -1) return '-'
    if (flag !== -1) return enumList[key][flag][label]
    if (flag_other !== -1) return enumList[key][flag_other][label]
  }

  /**
   * 处理时间
   * @param {*} val1
   * @param {*} val2
   * @returns
   */
  Vue.prototype.handlerDate = function (val1, val2) {
    if (!val1 && !val2) return '-'
    if (val1 && !val2) return dayjs(val1).format('YYYY-MM-DD') + ' 至 -'
    if (!val1 && val2) return '- 至 ' + dayjs(val2).format('YYYY-MM-DD')
    if (new Date(val1).getFullYear() === new Date(val2).getFullYear()) return dayjs(val1).format('YYYY-MM-DD') + ' 至 ' + dayjs(val2).format('MM-DD')
    return dayjs(val1).format('YYYY-MM-DD') + ' 至 ' + dayjs(val2).format('YYYY-MM-DD')
  }

  /**
   * 处理下拉选择器值为对象的情况
   * @param {*} obj
   * @param {*} key1
   * @param {*} key2
   * @param {*} type
   * @returns
   */
  Vue.prototype.handlerFormObjData = function (obj, key1, key2, type) {
    if (!obj[key1] || !obj[key1].length) return
    obj[key2] = ''
    obj[key1] = obj[key1].map(e => {
      //
      if (Object.prototype.toString.call(e) === '[object Object]') {
        if (e.name) obj[key2] += e.name + '、'
        return e.id
      }
    })
    if (type === 'str') obj[key1] = obj[key1].toString()
    if (obj[key2]) obj[key2] = obj[key2].substring(0, obj[key2].length - 1)
    if (type === 'key2Arr') obj[key2] = obj[key2].split('、')
  }

  /**
   * 分割字符串
   * @param {*} str
   * @returns
   */
  Vue.prototype.splitCharacter = function (str) {
    if (!str) return []
    // Array.isArray
    if (Object.prototype.toString.call(str) === '[object Array]') return str
    let reg1 = str.match(RegExp(/,/))
    let reg2 = str.match(RegExp(/、/))
    let flag = reg1 ? ',' : reg2 ? '、' : ''
    return flag ? str.split(flag) : [str]
  }

  /**
   * 处理值需要转为对象的情况
   * @param {*} obj
   * @param {*} key1
   * @param {*} key2
   * @returns
   */
  Vue.prototype.handlerFormStrData = function (obj, key1, key2) {
    if (!obj[key1] || !obj[key2]) return
    let str1 = Object.prototype.toString.call(obj[key1]) === '[object String]' ? obj[key1].split(',') : obj[key1]
    let str2 = ''
    if (Object.prototype.toString.call(obj[key2]) === '[object String]') {
      let reg1 = obj[key2].match(RegExp(/,/))
      let reg2 = obj[key2].match(RegExp(/、/))
      let flag = reg1 ? ',' : reg2 ? '、' : ''
      str2 = flag ? obj[key2].split(flag) : [obj[key2]]
    } else {
      str2 = obj[key2]
    }
    obj[key1] = str1.map((e, i) => {
      return {
        id: e,
        name: str2[i],
      }
    })
    obj[key2] = ''
  }

  /**
   * 校验表单是否有更改
   * @param {*} newData
   * @param {*} oldData
   * @returns
   */
  Vue.prototype.diffEditForm = function (newData, oldData) {
    let result = {}
    Object.keys(oldData).forEach(key => {
      if (JSON.stringify(oldData[key]) !== JSON.stringify(newData[key])) {
        result[key] = newData[key]
      }
    })
    return result
  }
  Vue.prototype.newDiffEditForm = function (newData, oldData) {
    const result = {}

    const setNestedValue = (obj, path, value) => {
      const keys = path.split('.')
      let current = obj

      for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        if (i === keys.length - 1) {
          current[key] = value
        } else {
          current[key] = current[key] || {}
          current = current[key]
        }
      }
    }

    const getDiff = (obj1, obj2, path = '') => {
      const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)])

      allKeys.forEach(key => {
        const currentPath = path ? `${path}.${key}` : key
        const val1 = obj1[key]
        const val2 = obj2[key]

        // 处理基本类型和数组
        if (typeof val1 !== 'object' || typeof val2 !== 'object' || val1 === null || val2 === null) {
          if (val1 !== val2) {
            setNestedValue(result, currentPath, val2)
          }
        }
        // 递归处理对象
        else {
          getDiff(val1, val2, currentPath)
        }
      })
    }

    getDiff(oldData, newData)
    return result
  }
  /**
   * 处理表格数据是否有更改
   * @param {*} newData
   * @param {*} oldData
   * @returns
   */
  Vue.prototype.diffTableForm = function (newData, oldData) {
    let res = newData
      .map((e, i) => {
        if (JSON.stringify(e) !== JSON.stringify(oldData[i])) return e
      })
      .filter(e => e !== undefined)
    let obj = {
      id: [],
      noId: [],
    }
    res.forEach(e => {
      if (e.id) obj.id.push(e)
      if (!e.id) obj.noId.push(e)
    })
    return obj
  }

  /**
   * 判断对象是否为空
   * @param {*} obj
   * @returns
   */
  Vue.prototype.judgeObjISEmpty = function (obj) {
    return JSON.stringify(obj) === '{}'
  }

  /**
   * 计算列表table表格当前页数
   * @param {*} total
   * @param {*} pageNo
   * @param {*} pageSize
   * @param {*} num
   * @returns
   */
  Vue.prototype.countCurrentPage = function (total, pageNo, pageSize, num) {
    let totalPage = Math.ceil((total - num) / pageSize)
    let currentPage = pageNo > totalPage ? totalPage : pageNo
    return currentPage < 1 ? 1 : currentPage
  }

  /**
   * 处理身份证和社会信用代码前六后四中间隐藏
   * @param {*} str
   * @param {*} frontLen
   * @param {*} endLen
   * @returns
   */
  Vue.prototype.hiddenCardId = function (str, frontLen, endLen) {
    if (!str) return
    var len = str.length - frontLen - endLen
    var start = ''
    for (var i = 0; i < len; i++) {
      start += '*'
    }
    return str.substring(0, frontLen) + start + str.substring(str.length - endLen)
  }

  /**
   * 判断是否有操作权限，没有就隐藏操作列
   * @param {*} permissions 权限标识数组
   * @returns
   */
  Vue.prototype.hiddenTableColumn = function (permissions) {
    const permissionList = store.getters && store.getters.userPermissionItemLists
    let arr = permissionList.filter(e => permissions.indexOf(e.identify) > -1)
    return arr.length > 0
  }

  /**
   * 输入框只允许输入0-9999的数字
   * @param {*} event
   */
  Vue.prototype.onPrizeKeypress = function (event) {
    const regexp = new RegExp(`^[0-9][0-9]{0,3}$`)
    const value = event.target.value
    if (regexp.test(value) || value === '') {
      event.target.lastValue = event.target.value
    } else {
      event.target.value = event.target.lastValue ? event.target.lastValue : ''
    }
  }

  /**
   * 按回车查询
   * @param {*} callBack 需要执行的函数
   * @param {*} queryData 查询条件
   */
  Vue.prototype.handleEnter = function (callBack, queryData) {
    // this.$refs.selectref.blur()//隐藏下拉弹窗
    document.onkeydown = e => {
      // e.preventDefault()//阻止默认事件冒泡
      // 判断查询条件是否为空
      const params = Object.values(queryData).filter(e => e !== '')
      if (e.code === 'Enter' && params.length) callBack()
    }
  }

  /**
   * 获取当前月份的上一个月的第一天和最后一天
   * @param {*} isStart 查询条件
   */
  Vue.prototype.getLastMonth = function (isStart) {
    // 获取当前日期
    const now = dayjs()

    // 获取上一个月的第一天
    const startOfLastMonth = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD HH:mm:ss')

    // 获取上一个月的最后一天
    const endOfLastMonth = now.subtract(1, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss')
    return isStart === 1 ? startOfLastMonth : endOfLastMonth
  }

  /**
   * 编辑时，如果obj存在key为空（obj[key]为int类型时），将obj[key]转为0
   * @param {*} obj
   * @param {*} keys
   * @returns
   */
  Vue.prototype.handlerIntEmptyValue = function (obj, keys) {
    if (!keys || !keys.length) return
    keys.forEach(e => {
      if (obj[e] === '') obj[e] = 0
    })
  }

  /**
   * 根据不同的屏幕宽度换算字体大小
   * @param {*} fontsize
   * @returns
   */
  Vue.prototype.transformFontSize = function (fontsize) {
    const width = window.screen.width
    const ratio = width / 1920
    return parseInt(fontsize * ratio)
  }

  /**
   * 格式化金额
   * @param {*} amount
   * @returns
   */
  Vue.prototype.keepTwoDecimal = function (amount) {
    if (amount === '' || amount === null) return '-'
    return !amount ? '￥0.00' : '￥' + Number(amount).toFixed(2)
  }

  /**
   * 获取项目名称
   * @param {*} id
   * @param {*} list
   */
  Vue.prototype.getCommunityName = function (id, list = this.searchCommunities) {
    if (!id || !list) return '-'
    let arr = id
    if (!Array.isArray(id)) arr = arr.split(',')
    let str = ''
    arr.forEach(ele => {
      const index = list.findIndex(e => e.communityId === ele)
      if (index !== -1) str += list[index].communityName + '、'
    })
    return !str ? '-' : str.substring(0, str.length - 1)
  }

  /**
   * 获取公司名称
   * @param {*} id
   * @returns
   */
  Vue.prototype.getOrganizationName = function (id, list = store.getters.subsidiaryLists) {
    if (!id || !list) return '-'
    const index = list.findIndex(e => e.organizationId === id)
    if (index === -1) return '-'
    return list[index].organizationName
  }

  /**
   * 复制数据
   * @param {*} text
   */
  Vue.prototype.copyValue = function (text) {
    const textarea = document.createElement('textarea')
    textarea.value = text
    document.body.appendChild(textarea)
    textarea.select()

    try {
      // 尝试执行复制操作
      const success = document.execCommand('copy')
      if (success) {
        Message.success('复制成功')
      } else {
        Message.error('复制失败')
      }
    } catch (error) {
      Message.error('复制失败')
    }

    document.body.removeChild(textarea)
  }

  /**
   * 根据身份证号解析性别，出生年月
   * @param {*} idNumber 身份证号
   */
  Vue.prototype.validateIDCard = function (idNumber) {
    if (!idNumber) return
    const reg = /^(^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{3}(\d|X|x)$)/
    if (!reg.test(idNumber)) return
    let result = ''
    if (idNumber.length === 15) {
      result = validate15DigitID(idNumber)
    } else if (idNumber.length === 18) {
      result = validate18DigitID(idNumber)
    }
    // 校验15位身份证号
    function validate15DigitID(idNumber) {
      // 检查前6位是否为有效的地区编码
      const areaCode = idNumber.substring(0, 6)
      // 检查出生日期是否有效
      const year = parseInt(idNumber.substring(6, 8), 10) + 1900
      const month = parseInt(idNumber.substring(8, 10), 10)
      const day = parseInt(idNumber.substring(10, 12), 10)
      const date = `${year}-${month}-${day}`
      // 提取性别
      const lastDigit = parseInt(idNumber.substring(14, 15), 10)
      const gender = lastDigit % 2 === 0 ? 2 : 1
      return {
        areaCode,
        date,
        year: year < 10 ? '0' + year : year,
        month: month < 10 ? '0' + month : month,
        day: day < 10 ? '0' + day : day,
        gender,
      }
    }

    // 校验18位身份证号
    function validate18DigitID(idNumber) {
      // 检查前6位是否为有效的地区编码
      const areaCode = idNumber.substring(0, 6)
      // 提取出生日期
      const date = idNumber.substring(6, 14)
      const year = parseInt(idNumber.substring(6, 10), 10)
      const month = parseInt(idNumber.substring(10, 12), 10)
      const day = parseInt(idNumber.substring(12, 14), 10)

      // 提取性别
      const genderCode = parseInt(idNumber.substring(16, 17), 10)
      const gender = genderCode % 2 === 0 ? 2 : 1
      return {
        areaCode,
        date,
        year: year < 10 ? '0' + year : year,
        month: month < 10 ? '0' + month : month,
        day: day < 10 ? '0' + day : day,
        gender,
      }
    }
    return result
  }

  /**
   * 格式化日期
   * @param {*} date 日期
   * @param {*} format 格式
   * @returns
   */
  Vue.prototype.formatDate = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
    if (!date) return '-'
    return dayjs(date).format(format)
  }

  /**
   * date-picker默认打开显示的日期
   * @param {*} date 基准日期
   * @param {*} fun 方法
   * @param {*} type 类型
   * @param {*} day 天数
   * @returns
   */
  Vue.prototype.defaultDatePickerDate = (date, fun = 'add', type = 'day', day = 1) => {
    if (!date) return dayjs().format('YYYY-MM-DD HH:mm:ss')
    if (fun === 'add') return dayjs(date).add(day, type).format('YYYY-MM-DD HH:mm:ss')
    if (fun === 'subtract') return dayjs(date).subtract(day, type).format('YYYY-MM-DD HH:mm:ss')
  }

  /**
   * date-picker日期限制
   * @param {*} date 对照日期
   * @returns
   */
  Vue.prototype.pickerOptionsDate = (date, type = 'none') => {
    return {
      disabledDate: time => {
        if (!date) return dayjs(time).valueOf() > dayjs().valueOf()
        return type === 'only' ? dayjs(time).valueOf() < dayjs(date).valueOf() : dayjs(time).valueOf() < dayjs(date).valueOf() || dayjs(time).valueOf() > dayjs().valueOf()
      },
    }
  }

  /**
   * 判断日期是否超出限制，超出则置空
   * @param {*} key1 开始日期
   * @param {*} key2 结束日期
   * @returns
   */
  Vue.prototype.handlerDateIsAfter = (obj, key1 = 'beginDate', key2 = 'endDate', fun = '', type = 'day', day = 1) => {
    if (!obj[key1] || !obj[key2]) return
    let targetDate = dayjs(obj[key1])
    if (fun === 'add') targetDate = targetDate.add(day, type)
    if (fun === 'subtract') targetDate = targetDate.subtract(day, type)
    if (targetDate.isAfter(dayjs(obj[key2]))) {
      obj[key2] = ''
      return Message.error('结束日期不能早于开始日期')
    }
  }
}

export default install
